import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';

import { joinReact } from 'helpers/format';

import styles from './Breadcrumbs.module.scss';

interface BreadcrumbsProps {
  links?: Array<any>;
  account?: string;
  organizationName?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ links = [] }) => {
  const history = useHistory();

  links = [
    {
      label: 'Home',
      to: '/',
    },
    ...links,
  ];

  const linkSymbol = ' / ';

  function onClick(reload: boolean) {
    if (reload === true) {
      history.go(0);
    }
  }

  return (
    <div className={styles.container}>
      {joinReact(
        links.map((link, index) => {
          const { label, reload, Component, ...props } = link;
          if (props.to) {
            return (
              <NavLink
                key={index}
                onClick={() => onClick(reload)}
                className={styles.link}
                {...props}
              >
                {label}
              </NavLink>
            );
          } else {
            return (
              <Component key={index} className={styles.link} {...props}>
                {label}
              </Component>
            );
          }
        }),
        linkSymbol
      )}
    </div>
  );
};

export default Breadcrumbs;
